import { useState } from "react"
import "./index.scss"
import { getCardFrontImage,getCardBackImage } from "../../utils/image_helper";


export const Card = ({rank,suit,isSelected,toggleSelection}) => {
    const [isFlipped, setIsFlipped] = useState(true);
    const frontImage = getCardFrontImage(rank,suit);
    const backImage = getCardBackImage("Red",1);

    const flip = () =>{
        setIsFlipped(!isFlipped);
    }

  

    const selectedStyle = {
        border: "5px solid gold",
    
    }

    const regularStyle = {
        border: "none",
    }

    const cardStyle = isSelected ? selectedStyle : regularStyle;

    return (<div style={cardStyle} onClick={toggleSelection} className="card-container">
        {isFlipped ? <img src={frontImage} alt={`${rank} of ${suit}`}/> : <img src={backImage}/>}
    </div>);


}